import { useQuery } from '@tanstack/react-query';
import { getFinancesSaasDetails, queryKeys } from '@vgrubs/components';
import { SaasRange } from './saasDetails.helpers';

/**
 * What "Monthly Saas" is made of for one range: monthly payments by status
 * and per-order charges by location. Only fetched while the modal is open.
 */
export const useSaasDetails = (range: SaasRange, enabled: boolean) => {
  const query = useQuery({
    queryKey: queryKeys.admin.saasDetails.summary(range),
    queryFn: async () => {
      const { data } = await getFinancesSaasDetails(range);
      return data.data;
    },
    enabled,
  });

  return {
    details: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
